import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs';
import { FormSave } from '../interface/form-save';
import { MessageComponent } from '../message/message.component';

@Injectable({
  providedIn: 'root'
})
export class FormGuardService implements CanDeactivate<FormSave> {

  constructor(private modalService: BsModalService) {
  }
  config: ModalOptions = {
    backdrop: true,
    keyboard: false,
    animated: true,
    ignoreBackdropClick: true,
  };
  canDeactivate(component: FormSave,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (!component.isDataSaved()) {
      const subject = new Subject<boolean>();
      const modal = this.modalService.show(MessageComponent, this.config);
      modal.content.subject = subject;
      return subject.asObservable();
    }
    return true;
  }
}
